// extracted by mini-css-extract-plugin
export default {"SearchInput":"Search_SearchInput__sHC28","SearchBtn":"Search_SearchBtn__f+HJ3","SearchInputGroup":"Search_SearchInputGroup__4g3T4","SearchForm":"Search_SearchForm__4c6Yc"};